<template>
    <tr>
      <td class="has-text-centered">
        <button v-show="isComplete"
                class="button is-success"
                :class="{ 'is-loading': isSaving }"
                disabled>
          <font-awesome-icon icon="check" />
          &nbsp; Saved
        </button>

        <button v-show="!isComplete"
                class="button is-info"
                :class="{ 'is-loading': isSaving }"
                @click="save"
                :disabled="!canSave || isSaving">
          Save
        </button>
        <div>
          <b-tag v-show="hasError"
                 type="is-danger">
            Error saving some documents
          </b-tag>
        </div>
      </td>
      <td>
        <router-link :to="{ name: 'carrier-profile', params: {accountKey: carrierDetails.accountKey }}">
          {{ carrierDetails.accountFirstName }}
          {{ carrierDetails.accountLastName }}
        </router-link>
        <div>
          <b-tag> {{ carrierDetails.accountEmailAddress }} </b-tag>
        </div>
      </td>

      <td v-for="document in documentUploadList" :key="document.fieldName">
        <span v-if="carrierDetails.carrier[document.dbFieldName]">
          <font-awesome-icon icon="check" />
        </span>
        <input v-else type="file" @change="processFile(document, $event)" />
      </td>

      <!--
      <td>
        <span v-if="carrierDetails.carrier.carrierHasUploadedArticlesOfIncorporation">
          <font-awesome-icon icon="check" />
        </span>
        <input v-else type="file" @change="processFile('articles-of-incorporation', $event)" />
      </td>
      <td>
        <span v-if="carrierDetails.carrier.carrierHasUploadedDriversLicense">
          <font-awesome-icon icon="check" />
        </span>
        <input v-else type="file" @change="processFile('drivers-licenses', $event)" />
      </td>
      <td>
        <span v-if="carrierDetails.carrier.carrierHasUploadedVoidedCheck">
          <font-awesome-icon icon="check" />
        </span>
        <input v-else type="file" @change="processFile('voided-check', $event)" />
      </td>
      -->
    </tr>
</template>

<script>
import { isNull, isUndefined, isEmpty } from 'lodash-es'
import getBase64 from '@/helpers/fileToBase64'
import DocumentApi from '@/api-interface/document'
// import CarrierApi from '@/api-interface/carriers'
import CarrierFileUploads from '@/lookup-data/carrier-file-uploads'
// import wait from '@/helpers/wait'

export default {
  name: 'CarrierDocumentUpload-row',

  props: {
    carrierDetails: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      documentUploadList: CarrierFileUploads,
      documents: {},
      isSaving: false,
      isComplete: false,
      hasError: false
    }
  },

  computed: {
    canSave() {
      return !isEmpty(this.documents)
    }
  },

  methods: {
    async processFile(documentSettings, event) {
      const file = event.target.files[0]
      const name = file.name.split('.')
      const extension = name.pop()

      const doc = {
        documentName: `${documentSettings.fileName}.${extension}`,
        documentHolder: 'account',
        documentType: 'carrier_document',
        documentS3Key: `account/${this.carrierDetails.accountKey}/carrier_document/${documentSettings.fileName}`,
        documentHolderKey: this.carrierDetails.accountKey,
        documentData: await getBase64(file)
      }

      this.$set(this.documents, documentSettings.fieldName, doc)
    },

    async save() {
      this.isSaving = true
      this.hasError = false

      // will hold the result of each file upload (if there was one)
      const confirmationFlags = {}
      const uploadRequests = []

      this.documentUploadList.forEach((fileInfo) => {
        const s3File = this.documents[fileInfo.fieldName]
        if (!isNull(s3File) && !isUndefined(s3File)) {
          confirmationFlags[fileInfo.dbFieldName] = null
          const req = DocumentApi.upload(s3File)
            .then(() => {
              console.log(`Done uploading file - ${fileInfo.fieldName}`)
              confirmationFlags[fileInfo.dbFieldName] = true
            })
            .catch((err) => {
              // swallow any failures so that it doesn't break the promise chain
              this.hasError = true
              console.error(`Failed to save all file - ${fileInfo.fieldName}:`, err)
            })
          uploadRequests.push(req)
        }
      })

      try {
        await Promise.all(uploadRequests)
        this.isComplete = true
      } catch (err) {
        this.hasError = true
        console.error(`Failed to save all files`, err)
      } finally {
        // there is some strange bug on the backend where trying to update the carrier as soon a document is uploaded...
        // ... the changes get eliminated. so this delay is to get around that.
        // await wait(5000)
        // update the carrier account to set the proper flags
        // await CarrierApi.partialUpdate({ carrierId: this.carrierDetails.carrier.carrierKey, data: confirmationFlags })
        this.isSaving = false

        // reset stuff so user can keep uploading documents individually
        this.isComplete = false

        this.documents = {}
        this.$emit('uploaded')
      }
    }
  }
}
</script>

<style scoped>
input[type='file'] {
  width: 50%;
}
</style>
